/** The report's place while its chunk or its stored copy loads. */
export function EmailAuditReportSkeleton() {
  return (
    <div
      aria-hidden="true"
      className="h-[480px] w-full animate-pulse rounded-2xl bg-mk-tile motion-reduce:animate-none"
    />
  )
}
